  import React, { useContext, useEffect, useState } from 'react';
  import { useAPI } from '../../../../shared/services/api/API';
  import { WASHUB_CONSTANTS } from '../../../../shared/Constants';
  import dayjs from 'dayjs';
  import {
    Button,
    Card,
    CardActions,
    Grid,
    MenuItem,
    TextField,
  } from '@mui/material';
  import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
  import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { SpinnerContext } from '../../../../shared/SpinnerContext';
  export const CustomerRewashSummary = () => {
    const { axiosInstance, httpGet, httpPost, handleAlertBar } = useAPI();
    const [processingCenterId, setProcessingCenterId] = useState('');
    const [processingCenterData, setProcessingCenterData] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const { toggleSpinner } = useContext(SpinnerContext);
    const [isBusOrderNotFound, setIsBusOrderNotFound] = useState(false);
    // GET with API : BUSINESSSTORE Processing Center
    const fetchProcessingCenter = async () => {
      httpGet(`${WASHUB_CONSTANTS.API_URLS.BUSINESS_ORDER_GET_ALL_PROCESSING_CENTER}`).then((response) => {
        if (response.status === 200) {
          const allObj = { id: 0, name: 'All', description: 'All Processing Center' };
          const sortProcessingCenterArray: any[] = response?.data?.sort((a: any,b: any) => a?.name.toLowerCase().localeCompare(b.name.toLowerCase()));
          setProcessingCenterData([allObj, ...sortProcessingCenterArray]);
        }
      });
    };

    // POST with API : Generate Business Daily Customer Revenue Report
    const generateDailyCustomerRevenueReport = async () => {
      setIsBusOrderNotFound(false);
      toggleSpinner(true);
      const payload = {
        startDate: startDate.format('YYYY-MM-DD'),
        endDate: endDate.format('YYYY-MM-DD'),
        processingCenterId: processingCenterId,
      };
      axiosInstance
        .post(
          WASHUB_CONSTANTS.API_URLS
            .REPORT_GENERATE_CUSTOMER_REWASH_REPORT,
          payload,
          {
            headers: {
              Authorization: localStorage.getItem('jwtToken') || null,
            },
            responseType: 'blob',
          },
        )
        .then((response: any) => {
          if (response.status === 200) {
            const blob = new Blob([response.data], {type: 'application/xlsx'});
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const fileName = `Customer-rewash-${payload.startDate} to ${payload.endDate}.xlsx`;
            a.setAttribute('download', fileName);
            document.body.appendChild(a);
            a.click();
  
            a.remove();
            window.URL.revokeObjectURL(url);
          } else {
            console.log(response)
            if (response.data.error) {
              console.error(
                'Error fetching BusinessStoreInvoices: ',
                response.data.message,
              );
            }
          }
        }).catch((error: any) => {
          if (error.response && error.response.status === 400 ) {
            setIsBusOrderNotFound(true);
          } else {
            console.error('Error fetching BusinessStoreInvoices: ', error);
            handleAlertBar('error', `${error.message}`);
          }
        }).finally(() => {
          toggleSpinner(false);
        });
    };
  
    const [startDate, setStartDate] = useState(dayjs().subtract(5, 'days'));
    const [endDate, setEndDate] = useState(dayjs());
    const handleStartDateChange = (date: any) => {
      setStartDate(date);
    };
    const handleEndDateChange = (date: any) => {
      setEndDate(date);
    };
  
    // Business Store
    useEffect(() => {
      fetchProcessingCenter();
    }, []);

    return (
      <div>
        <Card sx={{ margin: '5px 15px' }} elevation={2}>
          <CardActions>
            <Grid container className="m-2" spacing={2}>
              <Grid item xs={12} sm={12} md lg>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label={'Start date'}
                    slotProps={{ textField: { variant: 'standard' } }}
                    name="startDate"
                    value={dayjs(startDate)}
                    onChange={handleStartDateChange}
                  />
                </LocalizationProvider>
              </Grid>
  
              <Grid item xs={12} sm={12} md lg>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label={'End date'}
                    slotProps={{ textField: { variant: 'standard' } }}
                    name="endDate"
                    value={dayjs(endDate)}
                    minDate={dayjs(startDate)}
                    onChange={handleEndDateChange}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={12} md lg>
                <TextField
                fullWidth
                key="processingCenter"
                label="Select Processing Center"
                name="processingCenter"
                variant="standard"
                select
                
                onChange={(e) => {
                  setProcessingCenterId(e.target.value);
                }}
                value={processingCenterId}
              >
                {processingCenterData.map((option: any) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
              </Grid>
              <Grid item>
                  <Button
                    variant="contained"
                    onClick={generateDailyCustomerRevenueReport}
                  >
                    Download the Report
                  </Button>
              </Grid>
            </Grid>
          </CardActions>
        </Card>
        {isBusOrderNotFound && (
          <div
            style={{
              margin: '5px 15px',
              width: '100%',
              height: '50px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '16px',
            }}
          >
            <div
              style={{
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '8px 16px',
              }}
            >
              Business Order Item not found for the selected date range.
            </div>
          </div>
        )}
      </div>
    );
  };
  